export default __webpack_public_path__ + "static/media/slozeno_p.4e32c6fa.png";